import React from 'react'
import NumberFormat, { InputAttributes } from 'react-number-format'
import { TextField } from '@mui/material'

import { INumberFormatCustom } from '../commonInterfaces'

const NumberFormatCustom = React.forwardRef<NumberFormat<InputAttributes>, INumberFormatCustom>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props

    const limitLengthTo = (values: any): boolean => {
      return values.value.length <= 4
    }

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        placeholder="123"
        type="password"
        allowNegative={false}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props?.name,
              value: values.value,
            },
          })
        }}
        isAllowed={limitLengthTo}
      />
    )
  }
)

export default function CreditCardCvv(): JSX.Element {
  return (
    <TextField
      className="credit-cvv"
      label="CVV"
      name="credit-card-cvv"
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
    />
  )
}
